import React, { ReactElement } from "react";
import {
    DragDropContext, Draggable, Droppable, DropResult,
} from "react-beautiful-dnd";

export default function SortableList<T>({
    items, onReorder, render, getId, listClassName, itemClassName, isReadOnly,
}: {
    items: T[],
    onReorder: (items: T[]) => void,
    render: (item: T, index: number) => ReactElement,
    getId: (item: T) => string;
    isReadOnly?: boolean;
    listClassName?: string;
    itemClassName?: string;
}) {
    const onDragEnd = (result: DropResult) => {
        if (!result.source || !result.destination) {
            return;
        }
        const copy = Array.from(items);
        const [item] = copy.splice(result.source.index, 1);
        copy.splice(result.destination?.index, 0, item);
        onReorder(copy);
    };
    if (isReadOnly) {
        return (
            <div className={listClassName}>
                {items?.mapFilter((item, index) => (
                    <div
                        key={getId(item)}
                        className={itemClassName}
                    >
                        {render(item, index)}
                    </div>
                ))}
            </div>
        );
    }
    return (
        <DragDropContext
            nonce={window.NONCE}
            onDragEnd={onDragEnd}
        >
            <Droppable
                droppableId="list"
                mode="standard"
                direction="vertical"
            >
                {dropStoppable => (
                    <div
                        ref={dropStoppable.innerRef}
                        // eslint-disable-next-line react/jsx-props-no-spreading
                        {...dropStoppable.droppableProps}
                        className={listClassName}
                    >

                        {items?.mapFilter((item, index) => {
                            const row = render(item, index);
                            const id = getId(item);
                            return !row ? undefined : (
                                <Draggable
                                    draggableId={id}
                                    key={id}
                                    index={index}
                                >
                                    {(provided /* snapshot */) => (
                                        <div
                                            // eslint-disable-next-line react/jsx-props-no-spreading
                                            {...provided.draggableProps}
                                            // eslint-disable-next-line react/jsx-props-no-spreading
                                            {...provided.dragHandleProps}
                                            ref={provided.innerRef}
                                            className={itemClassName}
                                        >
                                            {row}
                                        </div>
                                    )}
                                </Draggable>
                            );
                        })}
                        {dropStoppable.placeholder}
                    </div>

                )}
            </Droppable>
        </DragDropContext>
    );
}

SortableList.defaultProps = {
    listClassName: "",
    itemClassName: "",
    isReadOnly: false,
};
